import { ChevronDown, ChevronUp, Trash2 } from 'lucide-react'

import { CategoryItem, HeroItem, CollectionItem } from 'interfaces/widget-types'
import { InformationCircleIcon } from '@heroicons/react/24/outline'

interface Props {
    item: HeroItem | CategoryItem | CollectionItem
    index: number
    total: number
    onMoveUp: () => void
    onMoveDown: () => void
    onDelete: () => void
    children?: React.ReactNode
}

const CarouselItem = ({
    item,
    index,
    total,
    onMoveUp,
    onMoveDown,
    onDelete,
    children,
}: Props) => {
    const canMoveUp = index > 0
    const canMoveDown = index < total - 1

    return (
        <div className="flex items-center justify-between gap-3 p-3 border rounded-lg bg-white dark:bg-slate-800 shadow-sm">
            {/* Left: Image + Info */}
            {children && (children)}

            {/* Actions */}
            <div className="flex items-center gap-1">
                {/* Tooltip */}
                <div className="relative group mr-auto ml-2 mt-0 inline-block">
                    <InformationCircleIcon className="w-4 h-4 text-slate-500 cursor-pointer" />

                    <div className="absolute bottom-full right-0 -translate-y-0 mb-2 w-64 rounded-md bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 p-3 text-xs text-slate-700 dark:text-slate-200 shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-150 z-50
 ">
                       You can change the order of items (up to one level) using the up and down arrows.
                    </div>
                </div>
                <button
                    type='button'
                    onClick={onMoveUp}
                    disabled={!canMoveUp}
                    className="p-1 rounded hover:bg-gray-200 disabled:opacity-50"
                >
                    <ChevronUp size={18} />
                </button>

                <button
                    type='button'
                    onClick={onMoveDown}
                    disabled={!canMoveDown}
                    className="p-1 rounded hover:bg-gray-200 disabled:opacity-50"
                >
                    <ChevronDown size={18} />
                </button>

                <button
                    onClick={onDelete}
                    className="p-1 text-red-500 hover:bg-red-50 rounded"
                >
                    <Trash2 size={18} />
                </button>

            </div>
        </div>
    )
}

export default CarouselItem
